export const ValidationResponse = result => {
  let data;

  if (result.Ok) {
    data = { result: result.result[0], error: "" };
  } else {
    const msg = result.message 
      || (result.error && typeof result.error === 'string' ? result.error : null)
      || (result.error && (result.error.message || result.error.sqlMessage)) 
      || "";
    if (msg == undefined || msg == "") {
      data = { result: null, error: "Ocurrio un error inesperado" };
    } else {
      data = { result: null, error: msg };
    }
  }

  return data;
};
